import React from "react";
import { DatePicker } from "@material-ui/pickers";
import format from "date-fns/format";
import { Controller } from "react-hook-form";
import moment from "moment";
import InputAdornment from "@material-ui/core/InputAdornment";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

export default function DateComponentController({
  onChange,
  control,
  ...props
}) {
  const maxPastDateDays = 365;
  const maxFutureDateDays = 365;

  return (

    <Controller
      as={
        <DatePicker
          label={props.label}
          //disablePast
          // maxDate={new Date()}
          //  minDate={new Date()-2}
          fullWidth
          autoOk
          clearable
          required={props.required}
          disabled={props.disabled}
          views={["year", "month", "date"]}
          // shouldDisableDate={disableBeforeTwoMonthDates}
          // minDate={
          //   props.sendminmaxvalue
          //     ? moment(new Date()).subtract(props.sendminmaxvalue, "days")
          //     : undefined
          // }
          maxDate={
            props.sendminmaxvalue
              ? new Date()
              : undefined
          }
          // minDate={moment(new Date()).subtract(maxPastDateDays, "days")}
          // maxDate={
          //   props.mindate
          //     ? props.mindate
          //     : moment(new Date()).add(maxFutureDateDays, "days")
          // }
          error={props.error}
          margin="normal"
          //minDate={props.mindate}
          emptyLabel=""
          format="dd-MM-yyyy"
          inputVariant="outlined"
          style={{ cursor: "pointer" }}
          size="small"
          animateYearScrolling={false}
          leftArrowIcon={<ChevronLeftIcon />}
          rightArrowIcon={<ChevronRightIcon />}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <DateRangeOutlinedIcon
                  style={{ color: "grey", cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
        />
      }
      onChange={([date]) => {
        try {
          props.getValueChanged(
            date && moment(date).isValid()
              ? moment(date).format("YYYY-MM-DD")
              : null
          );
        } catch {
          //console.log("getvalueChnaged is not defined");
        }

        return date;
      }}
      name={props.name}
      rules={props.rules}
      control={control}
      defaultValue={
        props.defaultValue != null
          ? moment(props.defaultValue, "DD-MM-YYYY").format("YYYY-MM-DD")
          : null
      }
    />
  );
}
